import { render } from "./InvestmentAgreementCard.vue?vue&type=template&id=75874a50&scoped=true"
import script from "./InvestmentAgreementCard.vue?vue&type=script&lang=js"
export * from "./InvestmentAgreementCard.vue?vue&type=script&lang=js"

import "./InvestmentAgreementCard.vue?vue&type=style&index=0&id=75874a50&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75874a50"]])

export default __exports__